// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import cartLineSharedStyles from "@pace/App/SharedStyles/CartLineSharedStyles";
import { cartLineCardCondensedStyles } from "@pace/Overrides/Components/CartLineCardCondensed";
import { css } from "styled-components";

cartLineCardCondensedStyles.mainContainer = {
    css: css`
        display: grid;
        grid-template-columns:
            91px minmax(0, 600px) minmax(0, 143px) minmax(0, 138px) minmax(0, 111px) minmax(0, 135px)
            minmax(0, 12px);
        grid-column-gap: 12px;
        grid-auto-flow: column;
        padding: 0 12px;
        &:not(:last-child) {
            border-bottom: 1px solid ${getColor("common.border")};
        }
        &:nth-child(2n + 1) {
            background: ${getColor("common.ui11")};
        }
        &:last-child {
            border-radius: 0 0 4px 4px;
        }
        @media print {
            break-inside: avoid;
            page-break-inside: avoid;
        }
    `,
};

cartLineCardCondensedStyles.productDescriptionContainer = {
    css: css`
        border-right: 1px solid ${getColor("common.border")};
        padding: 18px 13px 18px 0;
        grid-column: 1 / 4;
    `,
};
cartLineCardCondensedStyles.productErpNumberContainer = {
    css: css`
        border-right: 1px solid ${getColor("common.border")};
        padding: 18px 0;
        grid-column: 2 / 3;
        display: flex;
        flex-direction: column;
    `,
};

cartLineCardCondensedStyles.productPriceContainer = {
    css: css`
        border-right: 1px solid ${getColor("common.border")};
        padding: 18px 0;
        grid-column: 4 / 5;
    `,
};
cartLineCardCondensedStyles.quantityContainer = {
    css: css`
        border-right: 1px solid ${getColor("common.border")};
        padding: 18px 0;
        grid-column: 5 / 6;
    `,
};
cartLineCardCondensedStyles.totalContainer = {
    css: css`
        padding: 18px 0;
        grid-column: 6 / 7;
    `,
};

cartLineCardCondensedStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

cartLineCardCondensedStyles.price = {
    ...cartLineSharedStyles.productPrice,
};

cartLineCardCondensedStyles.extendedUnitNetPrice = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};

cartLineCardCondensedStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};
